// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__-G6BL"};